/**
 *
 * @module paywall
 *
 */

import Check from 'check-types';

import Exception from './../exception/entry';

import Product from './product';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    array,
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class Paywall
 * @desc Contains sku, campaign and account context information for a given country, platform and account/device.
 *
 */
export default class Paywall {

    /**
     *
     * @param {Object} options
     * @param {String<SDK.Services.Paywall.AccountEntitlementContext>} options.accountEntitlementContext
     * @param {String} options.paywallHash
     * @param {Array<SDK.Services.Paywall.Product>} options.products
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: `${this.constructor.name}(options)`,
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get accountEntitlementContext() {
                return `${this.ctor} options.accountEntitlementContext should be a String with length`;
            },
            get paywallHash() {
                return `${this.ctor} options.paywallHash should be a String with length`;
            },
            get products() {
                return `${this.ctor} options.products should be an Array of SDK.Services.Paywall.Product`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { accountEntitlementContext, paywallHash, products } = options;

        nonEmptyString(accountEntitlementContext, errorMessage.accountEntitlementContext, InvalidArgumentException);
        nonEmptyString(paywallHash, errorMessage.paywallHash, InvalidArgumentException);

        array.of.instanceStrict(products, Product, errorMessage.products, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String<SDK.Services.Paywall.AccountEntitlementContext>}
         * @desc Account contexts such as new, existing etc.
         *
         */
        this.accountEntitlementContext = accountEntitlementContext;

        /**
         *
         * @access public
         * @type {String}
         * @desc A base64 encoded MD5 hash of country and account context,
         * the source string is country_code+context (i.e usnew).
         *
         */
        this.paywallHash = paywallHash;

        /**
         *
         * @access public
         * @type {Array<SDK.Services.Paywall.Product>}
         * @desc The list of products represented by the paywall.
         *
         */
        this.products = products;

    }

}



// WEBPACK FOOTER //
// ./src/services/paywall/paywall.js